import { useCallback } from "react";

import snackMessages from "~/helpers/snackMessages";
import useMutationRunner from "~/hooks/useMutationRunner";
import {
	useDismissOnboardingWelcomeMutation,
	useSnoozeOnboardingWelcomeMutation
} from "~/services/endpoints/apiEndpoints";

export interface UseOnboardingWelcomeMutationsReturn {
	dismissWelcome: () => Promise<boolean>;
	snoozeWelcome: () => Promise<boolean>;
}

const ENTITY_LABEL = "Setting";

const useOnboardingWelcomeMutations = (): UseOnboardingWelcomeMutationsReturn => {
	const { run } = useMutationRunner();
	const [dismissMutation] = useDismissOnboardingWelcomeMutation();
	const [snoozeMutation] = useSnoozeOnboardingWelcomeMutation();

	const dismissWelcome = useCallback(
		() => run(dismissMutation(), (data) => data.dismissOnboardingWelcome, snackMessages.updateError(ENTITY_LABEL)),
		[dismissMutation, run]
	);

	const snoozeWelcome = useCallback(
		() => run(snoozeMutation(), (data) => data.snoozeOnboardingWelcome, snackMessages.updateError(ENTITY_LABEL)),
		[run, snoozeMutation]
	);

	return { dismissWelcome, snoozeWelcome };
};

export default useOnboardingWelcomeMutations;
